import { ApiClient } from "../api.client";
import {
  ForgotPasswordRequest,
  ForgotPasswordResponse,
  LoginRequest,
  LoginResponse,
  RefreshTokenRequest,
  RefreshTokenResponse,
  ResetPasswordRequest,
  ResetPasswordResponse,
  SetPasswordRequest,
  SetPasswordResponse,
  VerifyResetPasswordRequest,
  VerifyResetPasswordResponse
} from "./types";

const AuthApi = {
  login(body: LoginRequest) {
    return ApiClient.post<LoginRequest, LoginResponse>(
      "/affiliates/login",
      body
    );
  },
  setPassword(body: SetPasswordRequest) {
    return ApiClient.post<SetPasswordRequest, SetPasswordResponse>(
      "/affiliates/set-password",
      body
    );
  },
  refreshLogin() {
    return ApiClient.post<RefreshTokenRequest, RefreshTokenResponse>(
      "/affiliates/refresh-token"
    );
  },
  forgotPassword(body: ForgotPasswordRequest){
    return ApiClient.post<ForgotPasswordRequest,ForgotPasswordResponse>(
        "/affiliates/forgot-password",
        body
    );
  },
  verifyResetPasswordCode(body: VerifyResetPasswordRequest){
    return ApiClient.post<VerifyResetPasswordRequest, VerifyResetPasswordResponse>(
        "/affiliates/verify-reset-password",
        body
    );
  },
  resetAffiliatePassword(body: ResetPasswordRequest){
    return ApiClient.post<ResetPasswordRequest, ResetPasswordResponse>(
        "/affiliates/reset-password",
        body
    );
  }
};

export { AuthApi };
